export default defineNuxtLink({
    componentName: "MenuLink",
    activeClass: "bg-emphasis bg-transparent"
})